module.exports = function() {
  return new Worker(__webpack_public_path__ + "27a99cbeba49b18f4770.worker.js");
};